<template>
  <Moveable
        className="moveable"
        ref="MoveableRef"
        v-bind:target="[getActiveObject]"
        v-bind:draggable="true"
        v-bind:rotatable="true"
       
        v-bind:resizable="{
                // edge: ['e', 'w' , 'nw', 'ne', 'se', 'sw'],
                // renderDirections: ['e', 'w' , 'nw', 'ne', 'se', 'sw'],
                edge: ['e', 'w' , 'n', 's'],
                renderDirections:(getActiveCanvasObjProps?.type === 'img' || getActiveCanvasObjProps?.type === 'Rectangle' || getActiveCanvasObjProps?.type === 'Triangle' || getActiveCanvasObjProps?.type === 'Ellipse' || getActiveCanvasObjProps?.type === 'webpageApp') ? ['nw','n','ne','w','e','sw','s','se'] : getActiveCanvasObjProps?.type === 'Line' ?  ['n','s'] : ['nw','ne','w','e','sw','se'],
                // renderDirections:getActiveCanvasObjProps?.type === 'img' ? ['nw','n','ne','w','e','sw','s','se'] : getActiveCanvasObjProps?.type === 'Line' ?  ['n','s'] : ['w','e'],
            }"
       
       
            triggerAblesSimultaneously="true"

        v-bind:keepRatio="keepratio"
        v-bind:padding="{ left: 0, top: 0, right: 0, bottom: 0 }"
        v-bind:origin="false"
        v-bind:roundable="false"
        v-bind:roundClickable="false"
        v-bind:roundRelative="false"
        v-bind:minRoundControls="[1, 0]"
        v-bind:snappable="true"
        v-bind:verticalGuidelines=[237,471,705]
        v-bind:horizontalGuidelines=[163,323,483]
        v-bind:snapThreshold="5"
        v-bind:snapRenderThreshold="1"
        v-bind:isDisplaySnapDigit="true"
        v-bind:snapGap="true"
        v-bind:snapDirections="{top:true,right:true,bottom:true,left:true,center: true, middle: true}"
        v-bind:elementSnapDirections="{top:true,right:true,bottom:true,left:true}"
        v-bind:snapDigit="0"
        v-bind:elementGuidelines="elementGuidelines"
        @drag="onDrag"
        @dragEnd="onDragend"
        @rotate="onRotate"
        @rotateEnd="onRotateEnd"
        @resize="onResize"
        @resizeEnd="OnResizeEnd"
        @round="onRound"
        @click="onClick"
        @beforeResize="onBeforeResize"
        @resizeStart="onResizeStart"
    />
</template>
<!-- v-bind:scalable="{
    edge: ['nw', 'ne', 'se', 'sw'],
    renderDirections: ['nw', 'ne', 'se', 'sw'],
}"
 @scale="onScale"
        @beforeScale="onBeforeScale"
        @scaleEnd="onScaleEnd" -->
<script>
import Moveable from 'vue-moveable';

export default {
  name: 'myDarg',
  components: {
    Moveable,
  },
  data() {
    return {
      elementGuidelines: [],
      targetWidth: "",
      targetHeight: "",
      resizeTranslate: "",
      resizeTranslateScale: "",
      rotate: 0,
      textFontSize: 0,
      keepratio: false,
      defautlTextWidth: "",
      defaultFontSize: "",
      scaledValues: {}
    }
  },
  mounted() {

    this.elementGuidelines = [...this.elementGuidelines, document.querySelector(".WrapperDiv")]
  },
  computed: {
    getActiveObject() {

      // return this.$store.getters.getActiveObject && this.$store.getters.getActiveObject.target 
      return this?.$store?.getters?.getActiveObject && !this?.$store?.getters?.getActiveObjectprops?.lock && !this?.$store?.getters?.getActiveObjectprops?.editable && this?.$store?.getters?.getActiveObject?.target
    },
    getActiveCanvasObjProps() {
      return this.$store.getters.getActiveObjectprops
    },
    getActiveCanvasObject() {

      let obj = this.$store.getters.getActiveObject && this.$store.getters.getActiveObject.target;
      let type = !!obj && obj.getAttribute("data-type");

      if (obj !== null && type !== null && type != "text") {
        return true
      } else {
        return false
      }
    },
    getZoom() {
      return this.$store.getters.getZoom
    },
    getObjects() {
      return this.$store.getters.getCurrentActiveCanvasObjects.length
    }
  },
  watch: {

    "$store.state.activeObjectprops": {
      handler() {

        // console.log(updatedValues)
        // console.log("ipdating values from active ob ject props")
        this.$refs.MoveableRef.updateRect();
        this.$refs.MoveableRef.updateTarget();
        this.$nextTick(function () {

          this.$refs.MoveableRef.updateRect();
          this.$refs.MoveableRef.updateTarget();


        })
      },
      deep: true,
      immediate: true

    },
    getZoom: {
      handler() {


        // console.log(updatedValues)
        this.$refs.MoveableRef?.updateRect();

      },
      deep: true,
      immediate: true
    },
    getObjects: {
      handler() {

        // console.log("checking new objects")
        // console.log(updatedValues)
        let newarr = this.$store.getters.getCurrentActiveCanvasObjects.at(-1);
        if (newarr?.id) {

          let element = document.querySelector("div[data-id-t=" + newarr?.id + "]");
          if (!this.elementGuidelines.includes(element)) {
            this.elementGuidelines = [...this.elementGuidelines, element];
            // console.log(this.elementGuidelines)
          }
        }

      },
      deep: true,
      immediate: true
    }

  },
  methods: {
    onDrag({ target, left, top }) {
      // console.log(moveable.state.guidelines);
      // console.log(
      //   moveable.props.elementGuidelines,
      //   moveable.state.elementRects,
      //   moveable.state.guidelines,
      // );
      target.style.left = `${left}px`;
      target.style.top = `${top}px`;
    },
    onDragend() {
      this.$store.dispatch("setCurrentObjectProperties", {
        top: parseInt(this.getActiveObject.style.top) / this.getZoom,
        left: parseInt(this.getActiveObject.style.left) / this.getZoom
      });
    },

    onRotate({ target, drag, rotate }) {
      const activeobj = this.getActiveCanvasObjProps;
      if (activeobj?.type === 'Line') {
        const inputEvent = drag?.inputEvent;
        const shiftHeld = inputEvent && inputEvent.shiftKey;
        let finalRotate = rotate;

        const snapAngles = [0, 45, 90, 135, 180, 225, 270, 315, 360];
        const stickyThreshold = 8;
        const lockDuration = 100;
        if (!this._snapLock) this._snapLock = { locked: false, until: 0, angle: null };

        let normAngle = ((rotate % 360) + 360) % 360;

        if (!shiftHeld) {
          const now = Date.now();
          if (this._snapLock.locked && now < this._snapLock.until) {
            finalRotate = this._snapLock.angle;
          } else {
            let foundSnap = false;
            for (let snap of snapAngles) {
              let snapVal = snap === 360 ? 0 : snap;
              if (Math.abs(normAngle - snapVal) < stickyThreshold) {
                this._snapLock = {
                  locked: true,
                  until: now + lockDuration,
                  angle: snapVal
                };
                finalRotate = snapVal;
                foundSnap = true;
                break;
              }
            }
            if (!foundSnap) {
              this._snapLock = { locked: false, until: 0, angle: null };
              finalRotate = normAngle;
            }
          }
        } else {
          finalRotate = rotate;
          this._snapLock = { locked: false, until: 0, angle: null };
        }

        target.style.transformOrigin = '50% 50%';
        target.style.transform = `rotate(${finalRotate}deg)`;
        this.rotate = finalRotate;
      } else {
        target.style.transform = drag.transform;
        this.rotate = rotate;
      }
    },
    onRotateEnd() {
      debugger // eslint-disable-line no-debugger

      this.$store.dispatch("setCurrentObjectProperties", {
        rotate: this.rotate
      });
    },

    // onBeforeResize(e) {
    //    debugger // eslint-disable-line no-debugger
    //     // console.log(e);

    //     let activeobj = this.getActiveCanvasObjProps;
    //     console.log("Checking default width : " + activeobj.width);
    //     if(activeobj.type === 'text' || activeobj.type === 'clockApp' || (activeobj.type === "calendarApp" && activeobj.cType === "half")){
    //       this.defautlTextWidth = activeobj.width;
    //       this.defaultFontSize = activeobj.fs;
    //     }
    //     if( activeobj.type === 'weatherApp' ){
    //       this.defautlTextWidth = activeobj.width;
    //       this.defaultFontSize = activeobj.fs;
    //     }
    //     if (e.inputEvent.shiftKey || activeobj.type === 'weatherApp') {
    //       this.keepratio = true;
    //     } else {

    //     if((JSON.stringify(e.startFixedDirection) === JSON.stringify([1,-1]) || JSON.stringify(e.startFixedDirection) === JSON.stringify([1,1]) || JSON.stringify(e.startFixedDirection) === JSON.stringify([-1,-1]) || JSON.stringify(e.startFixedDirection) === JSON.stringify([-1,1])) && (activeobj.type === "text" || activeobj.type === 'clockApp' || (activeobj.type === "calendarApp" && activeobj.cType === "half"))){
    //         this.keepratio = true;
    //     } else {
    //       this.keepratio = false;
    //     }
    //   }


    //   },
    // onResizeStart(e){
    //   console.log("resize start");
    //   let activeobj = this.getActiveCanvasObjProps;
    //   if(activeobj.type === 'img'){

    //     if(activeobj.url.includes('pexels.com')){
    //       e.target.firstChild.style.backgroundImage = `url(${activeobj.url.split("?")[0]}?auto=compress&cs=tinysrgb&h=650&w=940)`
    //     }

    //     if(activeobj?.url?.includes('unsplash.com')){
    //       e.target.firstChild.style.backgroundImage = `url(${activeobj.url.split("w=")[0]}w=400)`
    //     }

    //     }
    // },

    // onResize({ target, width, height, drag, direction }) {
    //   const activeobj = this.getActiveCanvasObjProps;
    //   const zoom = this.getZoom;
    //   const beforeTranslate = drag.beforeTranslate;
    //   const canvasRect = document.querySelector('.WrapperDiv').getBoundingClientRect();

    //   // Calculate new position (left/top) if resizing from left/top edges
    //   let left = (target.offsetLeft + beforeTranslate[0]) / zoom;
    //   let top = (target.offsetTop + beforeTranslate[1]) / zoom;

    //   // For left/top edge resize, adjust position so the element stays in place
    //   if (direction && direction[0] === -1) {
    //     left -= (width - target.offsetWidth) / zoom;
    //   }
    //   if (direction && direction[1] === -1) {
    //     top -= (height - target.offsetHeight) / zoom;
    //   }

    //   // Clamp position to canvas bounds
    //   left = Math.max(0, Math.min(left, canvasRect.width / zoom - width / zoom));
    //   top = Math.max(0, Math.min(top, canvasRect.height / zoom - height / zoom));

    //   // Apply width/height and transform
    //   target.style.width = `${width}px`;
    //   target.style.height = activeobj.type === "text" ? "auto" : `${height}px`;
    //   target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) rotate(${activeobj.rotate}deg)`;

    //   // Font size logic for text/clock/weather/calendar
    //   if (activeobj.type === "text" && this.keepratio) {
    //     let boxWidthinPercent = (width / this.defautlTextWidth) * 100;
    //     let fontsize = (this.defaultFontSize / 100) * boxWidthinPercent;
    //     target.firstElementChild.firstElementChild.style.fontSize = `${fontsize}px`;
    //     this.textFontSize = fontsize;
    //   }
    //   // ...repeat similar logic for clockApp/weatherApp/calendarApp as needed...

    //   // Save for OnResizeEnd
    //   this.targetWidth = width;
    //   this.targetHeight = height;
    //   this.targetLeft = left;
    //   this.targetTop = top;
    //   this.resizeTranslate = beforeTranslate;
    //   this.$refs.MoveableRef?.updateRect();
    // },

    // OnResizeEnd({ target, direction }) {
    //   const activeobj = this.getActiveCanvasObjProps;
    //   const zoom = this.getZoom;
    //   const canvasRect = document.querySelector('.WrapperDiv').getBoundingClientRect();
    //   const rect = target.getBoundingClientRect();

    //   // Calculate left/top relative to canvas, adjusted for zoom
    //   let left = (rect.left - canvasRect.left) / zoom;
    //   let top = (rect.top - canvasRect.top) / zoom;
    //   let width = rect.width / zoom;
    //   let height = rect.height / zoom;

    //   // For left/top edge resize, adjust position
    //   if (direction && direction[0] === -1) {
    //     left = Math.max(0, left);
    //   }
    //   if (direction && direction[1] === -1) {
    //     top = Math.max(0, top);
    //   }

    //   // Clamp position to canvas bounds
    //   left = Math.max(0, Math.min(left, canvasRect.width / zoom - width));
    //   top = Math.max(0, Math.min(top, canvasRect.height / zoom - height));

    //   // Set final transform (rotation only, no translate)
    //   target.style.transform = `rotate(${activeobj.rotate}deg)`;

    //   // For images, update background if needed
    //   if (activeobj.type === 'img') {
    //     if (activeobj.url.includes('pexels.com')) {
    //       target.firstChild.style.backgroundImage = `url(${activeobj.url.split("?")[0]}?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)`;
    //     }
    //     if (activeobj.url.includes('unsplash.com')) {
    //       target.firstChild.style.backgroundImage = `url(${activeobj.url.split("w=")[0]}w=1080)`;
    //     }
    //   }

    //   // Prepare payload for store update
    //   const payload = {
    //     left,
    //     top,
    //     width,
    //     height,
    //     rotate: activeobj.rotate
    //   };

    //   // Add font size for text/clock/weather/calendar objects
    //   if (
    //     (activeobj.type === "text" && this.keepratio) ||
    //     ((["clockApp", "weatherApp"].includes(activeobj.type) || (activeobj.type === "calendarApp" && activeobj.cType === "half")) && this.keepratio)
    //   ) {
    //     payload.fs = parseInt(this.textFontSize / zoom);
    //   }

    //   // Update store once, after resize
    //   this.$store.dispatch("setCurrentObjectProperties", payload);

    //   // For weatherApp, set height to auto for DOM
    //   if (activeobj.type === 'weatherApp') {
    //     target.style.height = `auto`;
    //   }

    //   // Update Moveable rect
    //   this.$refs.MoveableRef?.updateRect();
    // },

    onBeforeResize(e) {
      const activeobj = this.getActiveCanvasObjProps;
      if (!activeobj) return;

      if (["text", "clockApp", "calendarApp", "weatherApp"].includes(activeobj.type)) {
        // Store original dimensions and font size
        this.originalWidth = e.target.offsetWidth;
        this.originalHeight = e.target.offsetHeight;
        
        const textEl = e.target.firstElementChild?.firstElementChild;
        if (textEl) {
          const computedFontSize = parseFloat(window.getComputedStyle(textEl).fontSize);
          this.defaultFontSize = isNaN(computedFontSize) ? 24 : computedFontSize;
          this.defautlTextWidth = this.originalWidth;
        } else {
          this.defaultFontSize = activeobj.fs || 24;
          this.defautlTextWidth = activeobj.width || 150;
        }
        this.textFontSize = this.defaultFontSize;
      }

      const cornerDirections = [
        [1, -1], [1, 1], [-1, -1], [-1, 1]
      ];
      if (
        e.inputEvent?.shiftKey ||
        (cornerDirections.some(d => JSON.stringify(d) === JSON.stringify(e.startFixedDirection)) &&
          ["text", "clockApp", "weatherApp", "calendarApp"].includes(activeobj.type))
      ) {
        this.keepratio = true;
      } else {
        this.keepratio = false;
      }
    },

    onResizeStart(e) {
      console.log("resize start");
      let activeobj = this.getActiveCanvasObjProps;
      if (activeobj.type === 'img') {

        if (activeobj.url.includes('pexels.com')) {
          e.target.firstChild.style.backgroundImage = `url(${activeobj.url.split("?")[0]}?auto=compress&cs=tinysrgb&h=650&w=940)`
        }

        if (activeobj?.url?.includes('unsplash.com')) {
          e.target.firstChild.style.backgroundImage = `url(${activeobj.url.split("w=")[0]}w=400)`
        }

      }
    },

    onResize({ target, width, height, drag, direction }) {
      const activeobj = this.getActiveCanvasObjProps;
      if (!activeobj) return;

      const zoom = this.getZoom;
      const beforeTranslate = drag.beforeTranslate;
      const canvasRect = document.querySelector('.WrapperDiv').getBoundingClientRect();

      let left = (target.offsetLeft + beforeTranslate[0]) / zoom;
      let top = (target.offsetTop + beforeTranslate[1]) / zoom;

      if (direction?.[0] === -1) {
        left -= (width - target.offsetWidth) / zoom;
      }

      if (direction?.[1] === -1) {
        top -= (height - target.offsetHeight) / zoom;
      }

      left = Math.max(0, Math.min(left, canvasRect.width / zoom - width / zoom));
      top = Math.max(0, Math.min(top, canvasRect.height / zoom - height / zoom));

      target.style.width = `${width}px`;

      // Handle height and scaling for different types
      if (activeobj.type === "clockApp") {
        // Maintain aspect ratio
        // const aspectRatio = this.originalWidth / this.originalHeight || 1;
        const adjustedHeight = height || this.originalHeight;
        target.style.height = `${adjustedHeight}px`;
        height = adjustedHeight;
        
        // Scale text based on width
        const textEl = target.firstElementChild?.firstElementChild;
        if (textEl) {
          const fontSize = Math.min(width, adjustedHeight) * 0.4;
          textEl.style.cssText = `
            font-size: ${fontSize}px;
            text-align: center;
            width: 100%;
            display: block;
          `;
          textEl.parentElement.style.cssText = `
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          `;
          this.textFontSize = fontSize;
        }
      } else if (["text", "calendarApp", "weatherApp"].includes(activeobj.type)) {
        target.style.height = "auto";
      } else {
        target.style.height = `${height}px`;
      }

      if (activeobj.type === "text" && this.keepratio) {
        const minFontSize = 6;
        const maxFontSize = 999; // no limit, optional

        if (this.defautlTextWidth > 0 && this.defaultFontSize > 0) {
          const scale = width / this.defautlTextWidth;
          let newFontSize = this.defaultFontSize * scale;

          newFontSize = Math.min(Math.max(newFontSize, minFontSize), maxFontSize);

          const textEl = target.firstElementChild?.firstElementChild;
          if (textEl) {
            textEl.style.fontSize = `${newFontSize}px`;
            textEl.style.whiteSpace = "normal";
            textEl.style.overflow = "visible";
            textEl.style.textOverflow = "unset";
            textEl.style.lineHeight = "1.2";
          }

          this.textFontSize = newFontSize;
        }
      }

      if (activeobj.type === "stickers") {
        const svgEl = target.querySelector("svg");

        if (svgEl) {
          svgEl.setAttribute("width", "100%");
          svgEl.setAttribute("height", "100%");
          svgEl.setAttribute("preserveAspectRatio", "xMidYMid meet");

          svgEl.style.width = "100%";
          svgEl.style.height = "100%";
          svgEl.style.objectFit = "contain";
          svgEl.style.display = "block";
          svgEl.style.margin = "auto";
        }
      }

      target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) rotate(${activeobj.rotate}deg)`;

      this.targetWidth = width;
      this.targetHeight = height;
      this.targetLeft = left;
      this.targetTop = top;
      this.resizeTranslate = beforeTranslate;

      this.$refs.MoveableRef?.updateRect();
    },

    OnResizeEnd({ target, direction }) {
      const activeobj = this.getActiveCanvasObjProps;
      const zoom = this.getZoom;
      const canvasRect = document.querySelector('.WrapperDiv').getBoundingClientRect();
      const rect = target.getBoundingClientRect();

      let left = (rect.left - canvasRect.left) / zoom;
      let top = (rect.top - canvasRect.top) / zoom;
      let width = rect.width / zoom;
      let height = rect.height / zoom;

      if (direction?.[0] === -1) left = Math.max(0, left);
      if (direction?.[1] === -1) top = Math.max(0, top);

      left = Math.max(0, Math.min(left, canvasRect.width / zoom - width));
      top = Math.max(0, Math.min(top, canvasRect.height / zoom - height));

      target.style.transform = `rotate(${activeobj.rotate}deg)`;

      const payload = {
        left,
        top,
        width,
        height,
        rotate: activeobj.rotate
      };

      // Handle final font size and dimensions
      if (
        ["text", "clockApp", "weatherApp", "calendarApp"].includes(activeobj.type) &&
        this.keepratio
      ) {
        const textEl = target.firstElementChild?.firstElementChild;
        if (textEl) {
          const finalFontSize = parseFloat(window.getComputedStyle(textEl).fontSize);
          // Prevent font size from jumping
          const scaledFontSize = parseInt(finalFontSize / zoom);
          payload.fs = Math.max(6, scaledFontSize); // Ensure minimum font size
          this.textFontSize = finalFontSize;
          
          // For clock app, maintain the final dimensions and styling
          if (activeobj.type === "clockApp") {
            payload.width = width;
            payload.height = height;
            
            // Calculate final font size based on dimensions with dynamic scaling
            const baseSize = Math.min(width, height);
            const scaleFactor = Math.max(0.3, 0.4 - (baseSize / 2000));
            const fontSize = baseSize * scaleFactor;
            payload.fs = fontSize / zoom; // Adjust for zoom level
            
            // Ensure the container maintains centering styles
            const container = target.firstElementChild;
            if (container) {
              container.style.height = '100%';
              container.style.display = 'flex';
              container.style.alignItems = 'center';
              container.style.justifyContent = 'center';
              
              const textEl = container.firstElementChild;
              if (textEl) {
                textEl.style.fontSize = `${fontSize}px`;
                textEl.style.textAlign = 'center';
                textEl.style.width = '100%';
                textEl.style.lineHeight = '1';
                textEl.style.whiteSpace = 'nowrap';
              }
            }
          }
        }
      }

      this.$store.dispatch("setCurrentObjectProperties", payload);

      if (activeobj.type === 'weatherApp') {
        target.style.height = `auto`;
      }

      this.$refs.MoveableRef?.updateRect();
    },

    onRound({ target, borderRadius }) {

      target.style.borderRadius = borderRadius;   // change dom style can work but can't be save when your node change
      target.firstElementChild.style.borderRadius = borderRadius;   // change dom style can work but can't be save when your node change

    },
    onClick({ target, hasTarget, containsTarget, targetIndex }) {

      console.log("onClick:", target, hasTarget, containsTarget, targetIndex);
    },

    //     onScale(e) {
    //       console.log(e)
    //       console.log("onScaleCalled")
    //       let worked = this.checkScale(e.target, `scale(${e.scale[0], e.scale[1]})`);
    //       console.log(e.drag.beforeTranslate)
    //       e.target.style.transform = e.drag.transform;
    //       this.scaledValues = worked;
    //       this.resizeTranslateScale = e.drag.beforeTranslate;
    //     },
    //     onBeforeScale() {
    //       this.keepratio = true;
    //     },
    //     onScaleEnd(e) {
    //       this.keepratio = false;
    //       e.target.style.transform = `rotate(${this.getActiveCanvasObjProps.rotate}deg)`;

    //       let activeobj = this.getActiveCanvasObjProps;
    //       let left = activeobj.left + (this.resizeTranslateScale[0] / this.getZoom);
    //       let top = activeobj.top + (this.resizeTranslateScale[1] / this.getZoom);




    // const fontSize = (this.scaledValues.width / this.getZoom + this.scaledValues.height / this.getZoom) / 20;



    //       this.$store.dispatch("setCurrentObjectProperties", {
    //         left: left,
    //         top: top,
    //         width: this.scaledValues.width / this.getZoom,
    //         height: this.scaledValues.height / this.getZoom,
    //         rotate: activeobj.rotate,
    //         fs:fontSize

    //       });
    //     },
    //     checkScale(scaledElement, scaleValue) {
    //       scaledElement.style.transform = scaleValue; // Change the scale value as needed

    //       // Get the computed dimensions of the element
    //       const computedStyle = getComputedStyle(scaledElement);
    //       const computedWidth = parseFloat(computedStyle.width);
    //       const computedHeight = parseFloat(computedStyle.height);

    //       // Calculate the scaled dimensions
    //       const scaleMatrix = new DOMMatrixReadOnly(scaledElement.style.transform);
    //       const scaledWidth = computedWidth * scaleMatrix.a;
    //       const scaledHeight = computedHeight * scaleMatrix.d;

    //       console.log(`Original Width: ${computedWidth}px`);
    //       console.log(`Original Height: ${computedHeight}px`);
    //       console.log(`Scaled Width: ${scaledWidth}px`);
    //       console.log(`Scaled Height: ${scaledHeight}px`);
    //       return { width: scaledWidth, height: scaledHeight }
    //     }

  }

}

</script>
<style scoped>
.position-absolute {
  position: absolute
}
</style>
